import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next';
import { isMobileContext } from '../context/isMobileContext';
import { motion } from "framer-motion";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/free-mode";
import { Navigation } from "swiper";
import PartnerCard from './PartnerCard';
const Partners = () => {
    const { isMobile } = useContext(isMobileContext);
    const { t,i18n } = useTranslation();
    const partners=[
        {
            img:'/imgs/appendices/p1.png',
            name:t("partnersAppendices.p1")
        }, {
            img:'/imgs/appendices/p2.jpeg',
            name:t("partnersAppendices.p2")
        }, {
            img:'/imgs/appendices/p3.png',
            name:t("partnersAppendices.p3")
        }, {
            img:'/imgs/appendices/p4.png',
            name:t("partnersAppendices.p4")
        }, {
            img:'/imgs/appendices/p5.png',
            name:t("partnersAppendices.p5")
        }, {
            img:'/imgs/appendices/p6.png',
            name:t("partnersAppendices.p6")
        },{
            img:'/imgs/appendices/p7.png',
            name:t("partnersAppendices.p7")
        },{
            img:'/imgs/appendices/p8.png',
            name:t("partnersAppendices.p8")
        },{
            img:'/imgs/appendices/p9.png',
            name:t("partnersAppendices.p9")
        },{
            img:'/imgs/appendices/p10.png',
            name:t("partnersAppendices.p10")
        },{
            img:'/imgs/appendices/p11.png',
            name:t("partnersAppendices.p11")
        },{
            img:'/imgs/appendices/p12.jpg',
            name:t("partnersAppendices.p12")
        },{
            img:'/imgs/appendices/p13.png',
            name:t("partnersAppendices.p13")
        },{
            img:'/imgs/appendices/p14.png',
            name:t("partnersAppendices.p14")
        },
    ]
    return (
        <div className='appendices-partners'>
            {/* <div className='first-bg'>
                <img
                src={process.env.PUBLIC_URL + '/imgs/appendices/partners-bg.png'}
                alt='background'
                />
            </div> */}
            {/* {isMobile&&<div className='second-bg'> */}
            <div className='second-bg'>
            <img
                src={process.env.PUBLIC_URL + '/imgs/appendices/partners-bg2.png'}
                alt='background'
                />
            </div>
            <div className='header-container'>
                <motion.h2
                    initial={{ opacity: 0, translateY: "100%" }}
                    whileInView={{ opacity: 1, translateY: 0 }}
                    viewport={{ once: true }}
                    transition={{ ease: "easeInOut", delay: isMobile ? 0.1 : 0.2, duration: 0.5 }}
                >{t("partnersAppendices.strategic")}</motion.h2>
                <motion.h2
                    initial={{ opacity: 0, translateY: "100%" }}
                    whileInView={{ opacity: 1, translateY: 0 }}
                    viewport={{ once: true }}
                    transition={{ ease: "easeInOut", delay: isMobile ? 0.1 : 0.2, duration: 0.5 }}
                >{t("partnersAppendices.partners")}</motion.h2>
            </div>
            <div className='cards-container'>
                <Swiper
                    key={Math.random(0, 100)}
                    centeredSlides={isMobile?true:false}
                    style={{ direction: i18n.language === "ar" ? "rtl" : "ltr" }}
                    breakpoints={{
                        0: {
                            slidesPerView: 1,
                            spaceBetween: 0,
                        },
                        1024: {
                            slidesPerView: 4,
                            spaceBetween: 0,
                        },
                    }}
                    modules={[Navigation]}
                    navigation={{
                        nextEl: `.partners-next`,
                        prevEl: `.partners-prev`,
                    }}
                    className="partners-swiper"
                >
                    {partners.map((p,index)=>(
                        <SwiperSlide key={index}>
                            <PartnerCard
                            img={p.img}
                            index={index}
                            name={p.name}
                            />
                        </SwiperSlide>
                    ))}

                </Swiper>
                <motion.div 
                 initial={{ opacity: 0 }}
                 whileInView={{ opacity: 1 }}
                 viewport={{ once: true }}
                 transition={{
                     ease: "easeInOut",
                     delay: .6,
                     duration: 0.5,
                 }}
                className="partners-navigation-container">
					<div className="swiper-button-prev partners-prev"></div>
					<div className="swiper-button-next partners-next"></div>
				</motion.div>
            </div>
        </div>

    )
}

export default Partners
